core.constant('opinionMeedyTranslationPL', {
  "T": {
    "MEEDY": {
      "SYSTEM": {
        "MESSAGE": {
          "OPINION": {
            "SAVE_ERROR": "Nie udało się wysłać opinii.",
            "FORM_INVALID": "Nie wypełniłeś żadnego z pól. Twoja opinia jest dla nas ważna. Wypełnij formularz i kliknij \"prześlij opinię\" ponownie.",
            "FORM_INVALID_TITLE": "Formularz zawiera błędy"
          }
        }
      },
      "UI": {
        "HEADER": {
        },
        "SIDEBAR": {
          "OPINION": "Uwagi i pomysły"
        },
        "BUTTON": {
          "OPINION": {
            "SAVE": "Prześlij opinię"
          }
        }
      },
      "MODULE": {
        "TITLE": {
          "OPINION": {
            "OPINION": "Uwagi i pomysły",
            "ADD": "Przekaż opinię i uwagi dotyczące funkcjonowania programu",
            "ADD_ROW2": "- co jest super, co musimy poprawić, czego Pani/Panu brakuje",
            "CONFIRMED": "Wysłane"
          }
        },
        "OPINION": {
          "MISSING_FEATURES": "Czego Pani/Panu brakuje?",
          "SUGGESTED_IMPROVEMENTS": "Co musimy poprawić (np. co nie działa jak powinno, co powinno zostać zrobione inaczej)?",
          "APPRECIATED_FEATURES": "Co jest super?",
          "CONFIRMED": {
            "MAIN_TEXT": "Każda przesłana przez Panią/Pana opinia jest dla nas bardzo ważna. Każdą czytamy i analizujemy.",
            "MAIN_TEXT_ROW2": "Dzięki opiniom możemy tworzyć rozwiązania, z których chcecie Państwo korzystać.",
            "MAIN_TEXT_ROW3": "Dziękujemy za współpracę i pomoc."
          }
        }
      }
    }
  }
});
